<template>
  <v-flex>
    <div class="mb-6">
      <v-btn to="/deal/list" color="blue">上一頁</v-btn>
    </div>

    <v-form @submit.prevent="submit()" v-model="valid">
      <v-card flat tile class="mb-6">
        <v-card-text>
          <p class="title mb-6">檢視/修改優惠方案</p>

          <v-text-field
            v-model="tempData.display_name"
            :rules="[formRules.required]"
            hint="此方案名稱會顯示在消費者的付費頁面，讓使用者方便選擇方案。"
            :persistent-hint="true"
            label="方案名稱"
            outlined
          ></v-text-field>
          <br />
          <v-text-field
            type="number"
            min="1"
            v-model.number="tempData.quantity"
            :rules="[formRules.amount]"
            label="點數"
            outlined
          ></v-text-field>
          <v-text-field
            type="number"
            min="1"
            v-model.number="tempData.price"
            :rules="[formRules.amount]"
            label="金額"
            outlined
          ></v-text-field>
          <v-select
            v-model="tempData.available"
            :items="mappingAvailable"
            item-text="text"
            item-value="value"
            placeholder="啟用狀態"
            outlined
          ></v-select>
        </v-card-text>
      </v-card>

      <div class="text-center">
        <v-btn @click="reset" outlined color="blue-grey lighten-3" class="mr-3">重設</v-btn>
        <v-btn @click="dialog = true" :disabled="!valid" color="teal">變更</v-btn>
      </div>
    </v-form>

    <Confirm @confirm="confirm" :dialog="dialog" title="是否確認變更優惠方案？" text />
  </v-flex>
</template>



<script>
import { mapState, mapActions } from "vuex";

import DataMixin from "@/mixins/Data";

import dealApi from "@/api/deal";

import Confirm from "@/components/Confirm";

export default {
  components: {
    Confirm
  },

  mixins: [DataMixin],

  props: [],
  data() {
    return {
      id: 0,

      deal: {},
      tempData: {},

      dialog: false,

      valid: false
    };
  },

  computed: {},
  watch: {},
  methods: {
    ...mapActions("system", ["set_snackbar"]),

    resHandling(res) {
      this.deal = JSON.parse(JSON.stringify(res.deal));
      this.tempData = JSON.parse(JSON.stringify(res.deal));
    },

    confirm(result) {
      this.dialog = false;

      if (result) {
        this.submit();
      } else {
        this.reset();
      }
    },

    reset() {
      this.tempData = JSON.parse(JSON.stringify(this.deal));
    },

    submit() {
      dealApi
        .updateByID(this.id, {
          display_name: this.tempData.display_name,
          quantity: this.tempData.quantity,
          price: this.tempData.price,
          available: this.tempData.available
        })
        .then(res => {
          if (res.status !== 0) {
            this.set_snackbar({
              color: "error",
              text: res.message
            });

            this.reset();
          } else {
            this.resHandling(res);
          }
        })
        .catch(err => {});
    }
  },

  mounted() {
    this.id = Number(this.$route.params.id);

    dealApi
      .getByID(this.id)
      .then(res => {
        this.resHandling(res);
      })
      .catch(err => {});
  }
};
</script>

<style lang="scss" scoped>
</style>
